function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import PropTypes from "prop-types";
import React, { Component } from "react";
import classnames from "classnames";
import AlertIcon from "../AlertIcon/AlertIcon";
import Base from "../Base/Base";
import Grid from "../Grid/Grid";
import GridCell from "../Grid/GridCell";
import Icon from "../Icon/Icon";
import Link from "../Typography/Link";
import Button from "../Button/Button";
import "./AlertBar.css";
export default class AlertBar extends Component {
  render() {
    const {
      children,
      size,
      type,
      onRemoveClick,
      closeButtonLabel,
      ...rest
    } = this.props;
    const classes = classnames("ax-alert-bar", `ax-alert-bar--${size}`, `ax-alert-bar--${type}`);
    return /*#__PURE__*/React.createElement(Base, _extends({}, rest, {
      className: classes,
      role: "alert"
    }), /*#__PURE__*/React.createElement(Grid, {
      gutters: "tiny",
      responsive: false,
      verticalAlign: "middle"
    }, /*#__PURE__*/React.createElement(GridCell, {
      shrink: true
    }, /*#__PURE__*/React.createElement(AlertIcon, {
      style: "subtle",
      theme: "day",
      type: type,
      className: "ax-alert-bar__icon"
    })), /*#__PURE__*/React.createElement(GridCell, {
      textColor: "night",
      textStrong: true
    }, children), onRemoveClick && /*#__PURE__*/React.createElement(GridCell, {
      shrink: true
    }, /*#__PURE__*/React.createElement(Button, {
      onClick: onRemoveClick,
      variant: "quaternary",
      size: "huge",
      "aria-label": closeButtonLabel || "Close alert"
    }, /*#__PURE__*/React.createElement(Icon, {
      isImg: false,
      name: "cross",
      className: "ax-alert-bar__dismiss-button--style-night"
    })))));
  }
}
_defineProperty(AlertBar, "defaultProps", {
  size: "small",
  type: "info"
});